export const contractDeploymentTx = "0x7a9ff4aa1907650889965326f049d6032400ce5fff296e9d1fb01a90a108b67b";
export const contractDeploymentTxLink = `https://rinkeby.etherscan.io/tx/${contractDeploymentTx}`;
// export const contractDeploymentTxLink = `https://explorer-dev.kardiachain.io/tx/${contractDeploymentTx}`;
export const medblockAddress = "0xDCf7095c19EB0068571c783D1Ac15E0bD266a798";